import Vue from "vue";
import App from "./App";
import EventBus from "./helpers/event-bus";
import router from "./router";
import VueI18n from "vue-i18n";
import VuePageTransition from "vue-page-transition";
import ElementUI from "element-ui";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "@lottiefiles/lottie-player";
import OneSignalVue from "onesignal-vue";
import tr from "./language/tr";
import en from "./language/en";
import Breadcrumb from "./components/Breadcrumb";
import PortalVue from "portal-vue";
import axios from "axios";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

import HolaconLottie from "./components/HolaconLottie.vue";
import HolaconLottieNoData from "./components/HolaconLottieNoData.vue";
import EventLinks from "./components/eventinfo/EventLinks.vue";
import UpgradeOverlay from "./components/upgrade/UpgradeOverlay.vue";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/bootstrap.css";
import "./assets/css/bootstrap_limitless.css";
import "./assets/css/layout.css";
import "./assets/css/components.css";
import "./assets/css/colors.css";
import "./assets/css/icons/icomoon/styles.min.css";
import "./assets/css/icons/fontawesome/styles.min.css";
import "./assets/css/theme.css";
import "./assets/css/custom.css";
import "./assets/css/animate.css";
import "./assets/css/plyr-ui.css";
import Sticky from "vue-sticky-directive";

import moment from "moment/min/moment-with-locales.js";
import VueTelInput from "vue-tel-input";
import VueMeta from "vue-meta";
import ActionableLabel from "./components/ActionableLabel";
import vueDebounce from "vue-debounce";
import "swiper/css/swiper.css";
import store from "./store/index";
//import $ from "jquery";
import VueMask from "v-mask";
import VueSlickCarousel from "vue-slick-carousel";
import InfiniteLoading from "vue-infinite-loading";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
Vue.component(CollapseTransition);
Vue.use(InfiniteLoading);
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
Vue.prototype.$currency = require("currency-formatter");
import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;
import vueClipboard from "v-clipboard";
Vue.use(vueDebounce);
Vue.use(vueClipboard);
Vue.use(VueMask);
Vue.use(VueAwesomeSwiper);
Vue.use(VueSlickCarousel);
import CoolLightBox from "vue-cool-lightbox";
Vue.use(CoolLightBox);

Vue.prototype.$currency = require("currency-formatter");
Vue.component("ActionableLabel", ActionableLabel);
// Vue.prototype.$eventbus = EventBus
Vue.mixin({
  methods: {
    openUpgradeDialog: function() {
      EventBus.$emit("upgradeModal");
    },
    openPaymentDetail: function(payment, participant) {
      EventBus.$emit("openPaymentDetail", payment, participant);
    },
    editSocialHubPost: function(target) {
      EventBus.$emit("editPost", target);
    },
    commentReplyChanged(target) {
      EventBus.$emit("commentReplyChange", target);
    },
    eventWrapperLoading: function(target) {
      EventBus.$emit("eventLoading", target);
    },
    exportXlsx: function(type, itemId, filter) {
      EventBus.$emit("exportXlsx", type, itemId, filter);
    },
    bulkDelete: function(list, json) {
      EventBus.$emit("bulkDelete", list, json);
    },
    sendVoucher: function(list, json) {
      EventBus.$emit("sendVoucher", list, json);
    },
    sendCertificate: function(list, json) {
      EventBus.$emit("sendCertificate", list, json);
    },
    importExcell: function(target) {
      EventBus.$emit("importExcell", target);
    },
    openParticipantDetail: function(target) {
      EventBus.$emit("openParticipantDetail", target);
    }
  }
});
Vue.component("HolaconLottie", HolaconLottie);
Vue.component("HolaconLottieNoData", HolaconLottieNoData);
Vue.component("UpgradeOverlay", UpgradeOverlay);
Vue.component("EventLinks", EventLinks);
Vue.use(OneSignalVue);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});
Vue.use(VueTelInput);
Vue.config.performance = true;
Vue.prototype.$moment = moment;
Vue.prototype.$imageus = "https://img.imageus.dev/";

import VCreditCard from "v-credit-card";
import "v-credit-card/dist/VCreditCard.css";
Vue.component("v-credit-card", VCreditCard);

import ParticipantMini from "./components/ParticipantMini";
import CustomTag from "./components/CustomTag";
import SpeakerSearch from "./components/SpeakerSearch";
import ProgramSearch from "./components/ProgramSearch";
Vue.use(Sticky);

const io = require("socket.io-client");

console.log(io);

Vue.prototype.$socket = io("https://socket.holacon.com", {
  transports: ["websocket"],
  upgrade: false,
  query: {
    token: localStorage.getItem("token")
  }
});

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBFvywbzSPYDlFHu58im4riFWW9xv-R5FY",
    libraries: "places"
  },
  installComponents: true
});
import trLocale from "element-ui/lib/locale/lang/tr-TR";
import enLocale from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";

import Geocoder from "@pderas/vue2-geocoder";

Vue.prototype.$helpUrl = "https://www.holacon.com/";

Vue.prototype.$helpMe = url => {
  if (url == null) return;
  window.open(url, "_blank");
};

Vue.prototype.$excelTemplateUrl = "https://www.holacon.com/";

Vue.prototype.validInput = function(key, validation) {
  return validation.some(k => k.key == key);
};

Vue.use(Geocoder, {
  defaultCountryCode: null,
  defaultLanguage: null, // e.g. 'en'
  defaultMode: "lat-lng", // or 'lat-lng'
  googleMapsApiKey: "AIzaSyBFvywbzSPYDlFHu58im4riFWW9xv-R5FY"
  //AIzaSyBFvywbzSPYDlFHu58im4riFWW9xv-R5FY - Cloud Console'da Holacon Console Projesinde
});
Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};
Vue.use(ElementUI, { locale });
// axios.defaults.baseURL = 'http://192.168.1.115:5020/v1/';
// axios.defaults.baseURL = 'http://178.233.224.8:5020/v1/'; // özkan bey static ip
axios.defaults.baseURL = "https://console-api.holacon.com/v1/";
//axios.defaults.baseURL = "http://localhost:5020/v1/";
// axios.defaults.baseURL = 'http://10.249.2.35:5020/v1/';
// axios.defaults.baseURL = "http://94.55.179.1:5020/v1/"; //gökçe statik ip

Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

Vue.prototype.$client = axios;
Vue.use(PortalVue);
Vue.component("CustomTag", CustomTag);
Vue.component("Breadcrumb", Breadcrumb);
Vue.component("ParticipantMini", ParticipantMini);
Vue.component("SpeakerSearch", SpeakerSearch);
Vue.component("ProgramSearch", ProgramSearch);
Vue.use(ElementUI);
Vue.use(VuePageTransition);
Vue.use(VueI18n);

const messages = {
  tr,
  en
};

var lang = localStorage.getItem("lang");
if (lang == null) {
  lang = navigator.language || navigator.userLanguage;
  lang = lang.substr(0, 2);

  if (lang != "en" && lang != "tr") {
    lang = "en";
  }
}
Vue.prototype.$toCamel = function toCamel(o) {
  var newO, origKey, newKey, value;
  if (o instanceof Array) {
    return o.map(function(value) {
      if (typeof value === "object") {
        value = toCamel(value);
      }
      return value;
    });
  } else {
    newO = {};
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
        value = o[origKey];
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toCamel(value);
        }
        newO[newKey] = value;
      }
    }
  }
  return newO;
};

Vue.prototype.$dateDisplayer = (start, end) => {
  // get total seconds between the times
  var delta = Math.abs(new Date(start) - new Date(end)) / 1000;

  // calculate (and subtract) whole days
  var days = Math.floor(delta / 86400);
  delta -= days * 86400;

  // calculate (and subtract) whole hours
  var hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;

  // calculate (and subtract) whole minutes
  var minutes = Math.floor(delta / 60) % 60;
  delta -= minutes * 60;

  // what's left is seconds
  var seconds = delta % 60; // in theory the modulus is not required

  if (days > 1) {
    return days + " days";
  } else if (days == 1) {
    return "1 day";
  } else if (hours > 1) {
    if (minutes > 1) {
      return hours + " h, " + minutes + " m";
    }
    return hours + " hours";
  } else if (hours == 1) {
    if (minutes > 1) {
      return hours + " h, " + minutes + " m";
    }
    return hours + " hour";
  } else if (minutes > 1) {
    return minutes + " minutes";
  } else if (minutes == 1) {
    return minutes + " minute";
  } else {
    return seconds + " seconds";
  }
};

if (lang === "en") locale.use(enLocale);
else locale.use(trLocale);

moment.locale(lang);
const i18n = new VueI18n({
  locale: lang,
  messages
});
Vue.prototype.dateFormatEvent = key => {
  var returned = "DD MMMM YYYY";
  if (key == 0) {
    returned = "DD MMMM YYYY";
  } else if (key == 1) {
    returned = "MMMM DD YYYY";
  }
  return returned;
};

Vue.prototype.datePickerDisplayFormat = function() {
  return "dd MMMM yyyy, ddd";
};

Vue.prototype.getParameterByName = (name, url = window.location.href) => {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

Vue.prototype.timeFormatEvent = key => {
  var returned = "HH:mm";
  if (key == 0) {
    returned = "HH:mm";
  } else if (key == 1) {
    returned = "h:mm A";
  }
  return returned;
};

Vue.prototype.getEnumsDisplay = function(category, key) {
  return this.$store.getters.getEnums.find(x => x.title == category).enums.find(x => x.key == key).displayName;
};
axios.defaults.headers["language"] = lang;

axios.interceptors.request.use(
  function(config) {
    var arr = config.url.split("?");
    if (arr.length > 1) {
      config.url = arr[0].toString() + "?" + arr[1].toString();
    } else {
      config.url = config.url.toLowerCase();
    }
    console.log("request", config.method, config.url, Object.freeze(config.data));
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    if (!response.data.alert.hasError) {
      console.log("response", response.config.method, response.config.url, Object.freeze(response.data));
    } else {
      console.warn("response", response.config.method, response.config.url, Object.freeze(response.data));
    }

    return response;
  },
  function(error) {
    console.log(error, "failed");
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response.status == 502) {
      //router.push({name:"maintenance"});
      // ElementUI.Message.error('Güzel kardeşim bu nasıl dosya evi ocağı yükle istersen');
    }
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false;

const guestRoutes = ["login", "register"];

axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (404 == error.response.status && error.config.url == "event/get") {
      router.push({ name: "new-account" });
      return Promise.reject(error);
    }

    if (401 === error.response.status) {
      router.push({ name: "login" });
      localStorage.removeItem("token");
      // error.response.data.alert = {
      //   hasError:true,
      //   message:"Yetkisiz erişim",
      // }
      // return error;
    } else if (403 === error.response.status) {
      window.vm.$message.error(i18n.t("message.authority"));
    } else {
      return Promise.reject(error);
    }
  }
);

router.beforeEach(async (to, from, next) => {
  const notAuthRoutes = ["login", "register", "forgot-password"];

  if (store.state.user.token != null && store.state.user.token != "null") {
    store.commit("setToken", localStorage.getItem("token"));
  }

  //$("html, body").animate({ scrollTop: 0 }, "slow");

  window.scrollTo({ top: 0, behavior: "smooth" });

  if (store.state.user.token != null && store.state.user.user == null && store.state.user.token != "null") {
    await store.dispatch("getUser");
    await store.dispatch("getAuthorizedEvents");

    // if user is present and try to go not auth routes
    if (to.name && notAuthRoutes.includes(to.name)) {
      return router.push({ name: "myevents" });
    }
  }

  /* page removed */
  // if (to.name == "new-account") {
  //   return next();
  // }

  // if (
  //     guestRoutes.indexOf(to.name) == -1 &&
  //     localStorage.getItem("token") != null &&
  //     localStorage.getItem("token") != "null"
  // ) {
  //     // check current event
  //     if (store.state.event.event == null) {
  //         var event = await store.dispatch("getEvent");
  //         store.dispatch("getUsers");
  //         store.dispatch("getSubEvents");
  //         store.dispatch("getGroups");
  //         store.dispatch("getTags");
  //     }
  // }

  if (to.name == "init") {
    if (store.state.event.event != null && store.state.user != null) {
      //console.log(store.state.event);
      router.push({ name: "myevents" });
    }
  }

  // if (guestRoutes.indexOf(to.name) == -1 && localStorage.getItem("token") != null && localStorage.getItem("token") != "null") {
  //     // check current event
  //     if (store.state.event.event == null) {
  //         var event = await store.dispatch("getEvent");
  //         store.dispatch("getUsers");
  //         store.dispatch("getSubEvents");
  //         store.dispatch("getGroups");
  //         store.dispatch("getTags");
  //     }
  // }

  // if (to.name == "init") {
  //   if (store.state.event.event != null && store.state.user != null) {
  //     //console.log(store.state.event);
  //     router.push({
  //       name: "event",
  //       params: { event_id: store.state.event.event.id },
  //     });
  //   }
  // }

  return next();
});

Vue.prototype.$parseCurrency = function(currencyCode) {
  if (currencyCode == 1) {
    return "TRY";
  } else if (currencyCode == 2) {
    return "USD";
  } else if (currencyCode == 3) {
    return "GBP";
  } else if (currencyCode == 4) {
    return "EUR";
  }
};
Vue.prototype.$errorMessage = (key, validationErrors) => {
  if (validationErrors.some(k => k.key == key)) {
    return validationErrors.find(k => k.key == key).value;
  } else {
    return null;
  }
};

Vue.prototype.$inputError = (key, validationErrors) => {
  if (validationErrors.some(k => k.key == key)) {
    return "has-error-input";
  } else {
    return "";
  }
};

Vue.prototype.$formatTimeSpan = time => {
  return moment().set({
    minutes: time.minutes,
    hours: time.hours,
    seconds: time.seconds,
    milliseconds: time.milliseconds
  });
};

Vue.prototype.$formatMoney = money => {
  return money.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

window.vm = new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  i18n,
  store,
  beforeMount() {
    if (window.location.hostname == "app.holacon.com") {
      this.$OneSignal.init({
        serviceWorkerParam: { scope: "/push/onesignal/" },
        serviceWorkerPath: "push/onesignal/OneSignalSDKWorker.js",
        serviceWorkerUpdaterPath: "push/onesignal/OneSignalSDKUpdaterWorker.js",
        appId: "7ef7de9c-3190-4172-a7e8-eb7ba01b94d3",
        safari_web_id: "web.onesignal.auto.2b467c5d-2ccd-4e09-a57b-cb7ab9efd0c0",
        autoResubscribe: true,
        notifyButton: {
          enable: false
        }
      });
    }
  }
});
Vue.prototype.$enums = {
  currency: [
    {
      value: 1,
      title: "TRY"
    },
    {
      value: 2,
      title: "USD"
    },
    {
      value: 3,
      title: "GBP"
    },
    {
      value: 4,
      title: "EUR"
    },
    {
      value: 0,
      title: i18n.t("enums.currency.other")
    }
  ],
  programRateStatus: [
    {
      value: 0,
      title: i18n.t("enums.status.waitApprove")
    },
    {
      value: 1,
      title: i18n.t("enums.status.approved")
    },
    {
      value: 2,
      title: i18n.t("enums.status.rejected")
    }
  ],
  discountType: [
    {
      value: 1,
      title: i18n.t("enums.discountType.discountPercentage")
    },
    {
      value: 2,
      title: i18n.t("enums.discountType.certainAmount")
    }
  ],
  accessTypes: [
    {
      value: 1,
      title: i18n.t("enums.accessTypes.all"),
      color: "darkgreen"
    },
    {
      value: 2,
      title: i18n.t("enums.accessTypes.certain"),
      color: "orange"
    },
    {
      value: 3,
      title: i18n.t("enums.accessTypes.onlyRegistrants"),
      color: "blue"
    }
  ],
  voucherSendStatus: [
    {
      value: 1,
      title: i18n.t("enums.voucherSendStatus.transmitted")
    },
    {
      value: 2,
      title: i18n.t("enums.voucherSendStatus.read")
    },
    {
      value: 3,
      title: i18n.t("enums.status.clicked")
    },
    {
      value: 4,
      title: i18n.t("enums.voucherSendStatus.failed")
    },
    {
      value: 10,
      title: i18n.t("enums.status.sent")
    },
    {
      value: 13,
      title: i18n.t("enums.voucherSendStatus.complaint")
    },
    {
      value: 12,
      title: i18n.t("enums.voucherSendStatus.noMail")
    },
    {
      value: 15,
      title: i18n.t("enums.voucherSendStatus.noPhone")
    },
    {
      value: 11,
      title: i18n.t("enums.voucherSendStatus.error")
    },
    {
      value: 14,
      title: i18n.t("enums.voucherSendStatus.unknownError")
    }
  ],
  voucherTaskStatus: [
    {
      value: 0,
      title: i18n.t("enums.voucherTaskStatus.duringShipping")
    },
    {
      value: 1,
      title: i18n.t("enums.voucherTaskStatus.complete")
    },
    {
      value: 2,
      title: i18n.t("enums.voucherTaskStatus.error")
    },
    {
      value: 100,
      title: i18n.t("enums.voucherTaskStatus.notesreferences")
    }
  ],
  voucherType: [
    {
      value: 0,
      title: i18n.t("enums.voucherTaskStatus.mail")
    },
    {
      value: 1,
      title: i18n.t("enums.voucherTaskStatus.sms")
    }
  ],
  paymentStatus: [
    {
      value: 0,
      title: i18n.t("enums.status.waitApprove")
    },
    {
      value: 1,
      title: i18n.t("enums.status.approved")
    },
    {
      value: 2,
      title: i18n.t("enums.status.canceled")
    }
  ],
  subEventRegistrationStatus: [
    {
      value: 0,
      title: i18n.t("enums.status.waitApprove")
    },
    {
      value: 1,
      title: i18n.t("enums.status.approved")
    },
    {
      value: 2,
      title: i18n.t("enums.status.canceled")
    }
  ],
  paymentType: [
    {
      value: 1,
      title: i18n.t("enums.paymentType.free")
    },
    {
      value: 2,
      title: i18n.t("enums.paymentType.online")
    },
    {
      value: 3,
      title: i18n.t("enums.paymentType.transfer")
    }
  ],
  activationStatus: [
    {
      value: 0,
      title: i18n.t("enums.activationStatus.wait")
    },
    {
      value: 1,
      title: i18n.t("enums.activationStatus.activated")
    },
    {
      value: 2,
      title: i18n.t("enums.activationStatus.canceled")
    }
  ],
  inputTypes: [
    {
      title: i18n.t("enums.inputTypes.uniqueMail"),
      value: 1
    },
    {
      title: i18n.t("enums.inputTypes.uniquePhone"),
      value: 2
    },
    {
      title: i18n.t("enums.inputTypes.company"),
      value: 3
    },
    {
      title: i18n.t("enums.inputTypes.title"),
      value: 4
    },
    {
      title: i18n.t("enums.inputTypes.school"),
      value: 5
    },
    {
      title: i18n.t("enums.inputTypes.department"),
      value: 6
    },
    {
      title: i18n.t("enums.inputTypes.sex"),
      value: 7
    },
    {
      title: i18n.t("enums.inputTypes.country"),
      value: 8
    },
    {
      title: i18n.t("enums.inputTypes.city"),
      value: 9
    },
    {
      title: i18n.t("enums.inputTypes.IdPassNO"),
      value: 20
    },
    {
      title: i18n.t("enums.inputTypes.studentNo"),
      value: 21
    },
    {
      title: i18n.t("enums.inputTypes.lang"),
      value: 22
    },
    {
      title: i18n.t("enums.inputTypes.birth"),
      value: 23
    },
    {
      title: i18n.t("enums.inputTypes.profession"),
      value: 24
    },
    {
      title: i18n.t("enums.inputTypes.expert"),
      value: 25
    },
    {
      title: i18n.t("enums.inputTypes.text"),
      value: 10
    },
    {
      title: i18n.t("enums.inputTypes.multilineText"),
      value: 11
    },
    {
      title: i18n.t("enums.inputTypes.mail"),
      value: 12
    },
    {
      title: i18n.t("enums.inputTypes.phone"),
      value: 13
    },
    {
      title: i18n.t("enums.inputTypes.figure"),
      value: 14
    },
    {
      title: i18n.t("enums.inputTypes.singlesreferences"),
      value: 15
    },
    {
      title: i18n.t("enums.inputTypes.multiChoice"),
      value: 16
    }
  ],
  invoiceType: [
    {
      title: i18n.t("enums.invoiceType.corpBilling"),
      value: 2
    },
    {
      title: i18n.t("enums.invoiceType.individualBilling"),
      value: 1
    }
  ],
  asktospeakerStatus: [
    {
      title: i18n.t("enums.status.autoApprove"),
      value: 1
    },
    {
      title: i18n.t("enums.status.waitForApprove"),
      value: 0
    }
  ],
  asktospeakerQuestionStatus: [
    {
      title: i18n.t("enums.status.waitApprove"),
      value: 0
    },
    {
      title: i18n.t("enums.currency.other"),
      value: 1
    },
    {
      title: i18n.t("enums.status.rejected"),
      value: 2
    },
    {
      title: i18n.t("enums.status.rejected"),
      value: 10
    }
  ],
  galleryType: [
    {
      title: "Video",
      value: 1
    },
    {
      title: i18n.t("enums.galleryType.photo"),
      value: 2
    }
  ],
  usageType: [
    { title: i18n.t("enums.usageType.eventCreated"), value: 1 },
    { title: i18n.t("enums.usageType.participantAdded"), value: 2 },
    { title: i18n.t("enums.usageType.participantsAdded"), value: 3 },
    { title: i18n.t("enums.usageType.participantRegistered"), value: 4 },
    { title: i18n.t("enums.usageType.eventAired"), value: 5 },
    { title: i18n.t("enums.usageType.smsActivation"), value: 6 },
    { title: i18n.t("enums.usageType.voucherSent"), value: 7 },
    { title: i18n.t("enums.usageType.invitationSent"), value: 8 },
    { title: i18n.t("enums.usageType.cardPrinted"), value: 9 },
    { title: i18n.t("enums.usageType.checkinDone"), value: 10 },
    { title: i18n.t("enums.usageType.inputControl"), value: 11 },
    { title: i18n.t("enums.usageType.promo"), value: 12 },
    { title: i18n.t("enums.usageType.report"), value: 13 },
    { title: i18n.t("enums.usageType.voucherSms"), value: 14 },
    { title: i18n.t("enums.usageType.liveSessionsCreated"), value: 15 },
    { title: i18n.t("enums.usageType.twoPerson"), value: 16 },
    { title: i18n.t("enums.usageType.fourPerson"), value: 17 },
    { title: i18n.t("enums.usageType.sixPerson"), value: 19 },
    { title: i18n.t("enums.usageType.liveParticipation"), value: 20 },
    { title: i18n.t("enums.usageType.enterNetworking"), value: 21 },
    { title: i18n.t("enums.usageType.liveSessionArchive"), value: 22 },
    { title: i18n.t("enums.usageType.manuel"), value: 23 },
    { title: i18n.t("enums.usageType.invitationAdded"), value: 24 },
    { title: i18n.t("enums.usageType.invitationSent"), value: 25 },
    { title: i18n.t("enums.usageType.couponUsed"), value: 100 },
    { title: i18n.t("enums.usageType.giftUsed"), value: 101 },
    { title: i18n.t("enums.usageType.loanPurchased"), value: 102 },
    { title: i18n.t("enums.usageType.certSent"), value: 26 }
  ],
  printMode: [
    { title: i18n.t("enums.printMode.dontCustom"), value: 0 },
    { title: i18n.t("enums.printMode.allCaps"), value: 1 },
    { title: i18n.t("enums.printMode.allLower"), value: 2 },
    { title: i18n.t("enums.printMode.firstCaps"), value: 3 }
  ],
  questionType: [
    {
      title: i18n.t("enums.questionType.textInput"),
      value: 1
    },
    {
      title: i18n.t("enums.questionType.single"),
      value: 2
    },
    {
      title: i18n.t("enums.questionType.multiple"),
      value: 3
    }
  ],
  accessLogType: [
    {
      title: i18n.t("enums.accessLogType.mobilLive"),
      value: 0
    },
    {
      title: i18n.t("enums.accessLogType.tourniquet"),
      value: 1
    }
  ],
  accessLogStatus: [
    {
      title: i18n.t("enums.accessLogStatus.granted"),
      value: 1
    },
    {
      title: i18n.t("enums.accessLogStatus.disallowed"),
      value: 2
    }
  ],
  rsvpStatus: [
    {
      title: i18n.t("enums.rsvpStatus.joining"),
      value: 5,
      color: "#3ae0a5"
    },
    {
      title: i18n.t("enums.rsvpStatus.disagree"),
      value: 6,
      color: "#e0473a"
    },
    {
      title: i18n.t("enums.rsvpStatus.maybe"),
      value: 4,
      color: "#e0a33a"
    },
    {
      title: i18n.t("enums.rsvpStatus.callAgain"),
      value: 7,
      color: "#e0a33a"
    },
    {
      title: i18n.t("enums.rsvpStatus.infoMistaken"),
      value: 9,
      color: "#e0a33a"
    },
    {
      title: i18n.t("enums.rsvpStatus.receiveComplaint"),
      value: 12,
      color: "#e0473a"
    },
    {
      title: i18n.t("enums.status.sent"),
      value: 1,
      color: "#3abae0"
    },
    {
      title: i18n.t("enums.status.delivered"),
      value: 2,
      color: "#3abae0"
    },
    {
      title: i18n.t("enums.status.clicked"),
      value: 3,
      color: "#3abae0"
    },
    {
      title: i18n.t("enums.status.spam"),
      value: 8,
      color: "#e0473a"
    },
    {
      title: i18n.t("enums.rsvpStatus.invalidMail"),
      value: 10,
      color: "#e0473a"
    },
    {
      title: i18n.t("enums.status.registered"),
      value: 11,
      color: "#3abae0"
    },
    {
      title: i18n.t("enums.status.opened"),
      value: 13,
      color: "#3abae0"
    },
    {
      title: i18n.t("enums.status.failed"),
      value: 14,
      color: "#e0473a"
    }
  ]
};

Vue.prototype.$formatImage = (text, mode, resolution) => {
  if (text == "" || text == null) {
    text = "http://holacon.s3.eu-central-1.amazonaws.com/public/default.jpg?v=555";
  }
  var temp = "";

  if (mode != "") temp += mode + "/";

  if (resolution != "") temp += resolution + "/";

  return "https://img.imageboss.me/" + temp.toString() + text.toString();
};

var serviceWorkerUnregistered = localStorage.getItem("serviceWorkerUnregistered");

if (serviceWorkerUnregistered == null) {
  localStorage.setItem("serviceWorkerUnregistered", "yes");
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let registration of registrations) {
      registration.unregister();
    }
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  });
}

Vue.prototype.$redirects = [
  {
    title: i18n.t("redirects.redirect1.title"),
    description: i18n.t("redirects.redirect1.description"),
    routes: [
      {
        title: i18n.t("event.buttons.go"),
        route: "program"
      }
    ]
  },
  {
    title: i18n.t("redirects.redirect2.title"),
    description: i18n.t("redirects.redirect2.description"),
    routes: [
      {
        title: i18n.t("event.buttons.go"),
        route: "groups"
      }
    ]
  },
  {
    title: i18n.t("redirects.redirect3.title"),
    description: i18n.t("redirects.redirect3.description"),
    routes: [
      {
        title: i18n.t("event.buttons.go"),
        route: "tags"
      }
    ]
  },
  {
    title: i18n.t("redirects.redirect4.title"),
    description: i18n.t("redirects.redirect4.description"),
    routes: [
      {
        title: i18n.t("event.buttons.go"),
        route: "packets"
      }
    ]
  },
  {
    title: i18n.t("redirects.redirect5.title"),
    description: i18n.t("redirects.redirect5.description"),
    routes: [
      {
        title: i18n.t("event.buttons.go"),
        route: "registration-form"
      }
    ]
  },
  {
    title: i18n.t("redirects.redirect6.title"),
    description: i18n.t("redirects.redirect6.description"),
    routes: [
      {
        title: i18n.t("event.buttons.go"),
        route: "venues"
      }
    ]
  },
  {
    title: i18n.t("redirects.redirect7.title"),
    description: i18n.t("redirects.redirect7.description"),
    routes: [
      {
        title: i18n.t("routes.speakers"),
        route: "speakers"
      },
      {
        title: i18n.t("routes.eventSch"),
        route: "program"
      },
      {
        title: i18n.t("routes.sponsors"),
        route: "sponsors"
      },
      {
        title: i18n.t("routes.areaMaps"),
        route: "area-maps"
      },
      {
        title: i18n.t("routes.docs"),
        route: "files"
      },
      {
        title: i18n.t("routes.library"),
        route: "questionlibrary"
      }
    ]
  },
  {
    title: i18n.t("redirects.redirect8.title"),
    description: i18n.t("redirects.redirect8.description"),
    routes: [
      {
        title: i18n.t("event.buttons.go"),
        route: "live-sessions"
      }
    ]
  }
];

// Özkan - Sentry iptal edildiği için kaldırıldı.
// import * as Sentry from "@sentry/browser";
// import { Integrations } from "@sentry/tracing";
// Sentry.init({
//   Vue,
//   dsn: "https://7cf11b5a6a4541738c31d13916aa89bb@o342749.ingest.sentry.io/5546899",
//   integrations: [
//     new Integrations.BrowserTracing(),
//   ],
//   tracesSampleRate: 1.0
// });



// WEBPACK FOOTER //
// ./src/main.js